// eslint-disable-next-line jira/restricted/react-component-props
import React, { Component, type ComponentProps } from 'react';
import type { Store } from 'redux';
import noop from 'lodash/noop';
import ViewTracker from '@atlassian/jira-analytics-web-react/src/components/view-tracker.tsx';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { initialQuery } from './model/constants/initial-query.tsx';
import type { Props } from './model/index.tsx';
import { isQueryChanged } from './model/query.tsx';
import rootEpic from './ops/index.tsx';
import { setAppProps } from './state/actions/app/index.tsx';
import {
	retrieve as retrieveDashboards,
	retrieved as retrievedDashboards,
} from './state/actions/dashboards/index.tsx';
import { setQuery } from './state/actions/query/index.tsx';
import createStore from './state/index.tsx';
import { getQuery } from './state/selectors/query/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line jira/react/no-class-components
export default class Dashboards extends Component<Props> {
	static defaultProps = {
		query: undefined,
		withPageReadyMetrics: true,
		prefetchedData: {},
		onUnmount: noop,
		onQueryChanged: noop,
	};

	constructor(props: Props) {
		super(props);
		this.store = createStore(rootEpic);

		const { dispatch } = this.store;
		const { dashboards } = props.prefetchedData;

		dispatch(setAppProps(props));
		dispatch(setQuery(props.query || initialQuery));

		if (dashboards) {
			dispatch(retrievedDashboards(dashboards));
		}
	}

	componentDidMount(): void {
		const { dispatch } = this.store;
		const { dashboards } = this.props.prefetchedData;

		if (!dashboards) {
			dispatch(retrieveDashboards());
		}
	}

	componentDidUpdate(): void {
		this.store.dispatch(setAppProps(this.props));

		// @ts-expect-error - TS2345 - Argument of type 'Partial<Query>' is not assignable to parameter of type 'Query'.
		if (this.props.query && isQueryChanged(this.props.query, getQuery(this.store.getState()))) {
			this.store.dispatch(setQuery(this.props.query));
			this.store.dispatch(retrieveDashboards());
		}
	}

	componentWillUnmount(): void {
		this.props.onUnmount();
	}

	store: Store<State>;

	render(): React.JSX.Element {
		return (
			<AppBase store={this.store} hasErrorBoundary={false}>
				<ReportErrors id="unhandled" packageName="jiraDashboardsMain" teamName="keystone">
					<ViewTracker />
					<AppStyle>
						{/* @ts-expect-error - TS2786 - Type 'any' is not assignable to type 'never'. */}
						<View />
					</AppStyle>
				</ReportErrors>
			</AppBase>
		);
	}
}

export type DashboardsProps = JSX.LibraryManagedAttributes<
	typeof Dashboards,
	ComponentProps<typeof Dashboards>
>;
